import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { connect, useDispatch } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { AlertAction } from '../../actions/AlertAction';
import { AuthAction } from '../../actions/AuthAction';
import { ProgramConstant } from '../../actions/constants/ProgramConstant';
import { NotificationAction } from '../../actions/NotificationAction';
import { ProgramAction } from '../../actions/ProgramAction';
import { ROLE_EXTERNAL_DEALER } from '../../config/appConstants';
import { Translate as t } from '../../config/Translate';
import { history } from '../../history';
import { getLicenseRole } from '../../lib/licenseHelper';
import { canUseAiSearch } from '../../lib/aiSearchGuard';
import RayGuardAiSearch from './RayGuardAiSearch';
import HomeAlaram from '../home/HomeAlaram';
import ServiceModalWarningIcon from '../servicemodal/ServiceModalWarningIcon';
import ServiceStatusBadge from '../servicestatus/ServiceStatusBadge';
import { InputBasicText, InputSelect2WithGroup } from './Inputs';
import { useConfirmDialog } from './ConfirmDialog';

// U-63: 모델 필터(ProgramReducer.showmodel)를 실제로 읽는 화면의 경로 접두(소문자).
// 읽는 곳: ProductAction(장비·재고·오류 목록), ServiceAction, SiteSurveyAction, InstallationAction,
// Aggregates·Map·WdigetItemCountCard(대시보드). 라이선스·사용자·회사 등은 읽지 않아 제외.
const MODEL_FILTER_PATHS = [
	'/admin/dashboard',
	'/admin/adminproductdashboard',
	'/admin/adminproductlist',
	'/admin/adminproductstocklist',
	'/admin/adminerrordashboard',
	'/admin/adminerrorlist',
	'/admin/adminservicedashboard',
	'/admin/adminservicelist',
	'/admin/adminsitedashboard',
	'/admin/adminwarrantydashboard',
	'/admin/adminsitesurveylist',
	'/admin/admininstallationlist',
];

const AdminTopMenu = ({ user, dashboardtype, DashboardType, automapplay, showSub, showChart, chartType, deviceCategory, SetDeviceCategory, Logout, clist, showmodel, ReadAll, DeleteAll, DeleteRead }) => {
	const { confirm, dialog } = useConfirmDialog();
	const location = useLocation()
	const isPmcf = location.pathname.toLowerCase() === '/pmcf';
	const [isDS, setIsDS] = useState(true);
	const isNotificationPage = location.pathname === '/Admin/AdminNotification';
	const lowerPath = (location.pathname || '').toLowerCase();
	const isModelFilterPage = MODEL_FILTER_PATHS.some(p => lowerPath === p || lowerPath.startsWith(p + '/'));
	const [sm, setSM] = useState(['']);
	const [hideMenu, setHideMenu] = useState(false);
	const [modal, setModal] = useState({
		show : false
	});
	const [searchPartModal, setSearchPartModal] = useState({
		show : false
	});
	const [showAS, setShowAS] = useState(false);
	const [partSn, setPartSn] = useState('');
	const [isSearching, setIsSearching] = useState(false);
	const dispatch = useDispatch();
	// FEAT-025 SPEC-RG-04 — ExternalDealer 는 RAY 장비/서비스 관련 UI 노출 안 함.
	// (Search Part / Filter / ServiceStatusBadge / Dashboard 링크 등)
	const isExternalDealer = getLicenseRole(user) === ROLE_EXTERNAL_DEALER;

	useEffect(() => {
		setIsDS(location.pathname === "/Admin/Dashboard");
	}, [location])

	useEffect(() => {
		setSM(showmodel);
	}, [showmodel])

	useEffect(() => {
		setHideMenu(user.companyId === 'RAY00016' && user.adminType === 'U')
	}, [user]);

	const getModels = () => {
		return [
			{ code : '', title : 'All Model' },
			...[...new Set(clist?.filter(x => x.type === 'PRODUCTOPTION').map(x => x.group))].map(x => ({ code : x, title : x }))
		];
	}

	const applyFilter = () => {
		dispatch({ type: ProgramConstant.SHOW_MODEL, showmodel : sm });
		setModal({...modal, show : false});
	}

	// Download file from URL
	const downloadFile = async (url, filename) => {
		try {
			const response = await fetch(url);
			if (!response.ok) {
				throw new Error('File not found');
			}
			const blob = await response.blob();
			const downloadUrl = window.URL.createObjectURL(blob);
			const link = document.createElement('a');
			link.href = downloadUrl;
			link.download = filename;
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			window.URL.revokeObjectURL(downloadUrl);
			return true;
		} catch (error) {
			return false;
		}
	}

	// Handle search and download functionality
	const handleSearchAndDownload = async () => {
		if (!partSn.trim()) {
			return;
		}

		setIsSearching(true);
		const urls = [
			{
				url: `https://rayguard-data.s3.ap-northeast-2.amazonaws.com/devices/DX_IR_CAL/DX_IR_CAL_${partSn}.zip`,
				filename: `DX_IR_CAL_${partSn}.zip`
			},
			{
				url: `https://rayguard-data.s3.ap-northeast-2.amazonaws.com/devices/DX_OCLV_CAL/DX_OCLV_CAL_${partSn}.zip`,
				filename: `DX_OCLV_CAL_${partSn}.zip`
			}
		];

		const foundFiles = [];

		// Check each URL sequentially and download if exists
		for (const fileInfo of urls) {
			try {
				// Try to download directly - if it works, file exists
				const downloaded = await downloadFile(fileInfo.url, fileInfo.filename);
				if (downloaded) {
					foundFiles.push(fileInfo);
				}
			} catch (error) {
				// File doesn't exist or download failed
				console.log(`File not found: ${fileInfo.filename}`);
			}
		}

		setIsSearching(false);

		if (foundFiles.length === 0) {
			dispatch(AlertAction.ErrorMsg('No data available.'));
		} else {
			dispatch(AlertAction.Success(`Downloaded ${foundFiles.length} file(s) successfully.`));
		}
	}

	return (
		<div className="appHeader bg-primary">
			<div className="left">
				{
					!hideMenu && !isPmcf &&
					<a className="headerButton" data-bs-toggle="modal"
						data-bs-target="#sidebarPanel"
						onClick={() => dispatch({ type: ProgramConstant.SIDEMENU_OPEN })}>
						<ion-icon name="menu-outline"></ion-icon>
					</a>
				}
				{/* IMP-419: 소속 회사명 SSoT = user.companyInfo. 기존 `companies.length == 1` 조건은
				    조회 스코프 목록이 우연히 1건인 계정에서만 노출돼 HQ/상위 법인·로드 실패 시 사라졌다. */}
				{user?.companyInfo?.name && <span className='text-bold text-white text-truncate d-inline-block align-middle' style={{ marginLeft: '20px', maxWidth: 220 }} title={user.companyInfo.name}>{user.companyInfo.name}</span>}
				{(isDS && dashboardtype == "map") &&
					<>
					{
						!hideMenu &&
						<>
							<a href className="headerButton" data-bs-toggle="modal"
								data-bs-target="#sidebarPanel"
								onClick={() => dispatch({ type: ProgramConstant.SET_SHOWSUB, showSub: !showSub })}>
								{!showSub && <ion-icon name="chevron-forward-circle-outline"></ion-icon>}
								{showSub && <ion-icon name="chevron-down-circle-outline"></ion-icon>}
							</a>

							<a href className="headerButton"
								onClick={() => dispatch({
									type: ProgramConstant.SET_CHARTOPT,
									showChart: !showChart,
									chartType: chartType
								})}>
								{!showChart && <ion-icon name="podium-outline"></ion-icon>}
								{showChart && <ion-icon name="podium"></ion-icon>}
							</a>
							<a href className="headerButton"
								onClick={() => dispatch({
									type: ProgramConstant.SET_CHARTOPT,
									showChart: showChart,
									chartType: chartType == "err" ? "acq" : "err"
								})}>
								{chartType == "err" && <ion-icon name="alert-circle-outline"></ion-icon>}
								{chartType == "acq" && <ion-icon name="camera-outline"></ion-icon>}
							</a>
						</>
					}
					</>
				}
				{!isPmcf && (
					<div className="pageTitle">
						<Link
							to={isExternalDealer ? "/Admin/License" : "/Admin/Dashboard"}
							className="text-white"
						>RAYGuard</Link>
					</div>
				)}
				{canUseAiSearch(user) && !isPmcf && <RayGuardAiSearch user={user} />}
				{!isExternalDealer && <ServiceStatusBadge />}
				{!isExternalDealer && <ServiceModalWarningIcon />}
			</div>
			<div className="right align-items-center">
				{!isPmcf && (
					<>
						{getLicenseRole(user) !== null && (
							<Link to="/Admin/License" className="btn btn-primary mt-0 me-2 d-inline-flex align-items-center" style={{ height: 42 }}>
								{t('license.title')}
							</Link>
						)}
						{!isExternalDealer && (
							<button className='btn btn-primary mt-0 me-2' type="button" style={{ height : 42}} onClick={() => setSearchPartModal({...searchPartModal, show : true})}>
								{t('service.button.downloadCalibration')}
							</button>
						)}
						{!isExternalDealer && isModelFilterPage && (
							<button className='btn btn-primary mt-0 me-2' type="button" style={{ height : 42}} onClick={() => setModal({...modal, show : true})}>
								{t('common.label.filter')} {showmodel[0] !== '' ? '(' + showmodel.length + ')' : '' }
							</button>
						)}
					</>
				)}
				{isDS && <div className="me-2">
					<span className="me-1 float-start">{t('site.map')}</span>
					<div className="form-check form-switch float-start" style={{ height: 24 }}>
						<input className="form-check-input" type="checkbox" checked={dashboardtype == "statistics"} onChange={() => DashboardType(dashboardtype == "statistics" ? "map" : "statistics")} />
						<label className="form-check-label" onClick={(e) => DashboardType(dashboardtype == "statistics" ? "map" : "statistics")} />
					</div>
					<span className="ms-1">{t('dashboard.label.statistics')}</span>
				</div>}
				{
					hideMenu &&
					<button className='btn btn-primary mt-0' type="button" style={{ height: '32px', marginRight: '20px', verticalAlign: 'middle', padding: '0 10px' }} onClick={() => Logout()}>
						{t('auth.button.signOut')}
					</button>
				}
				{isNotificationPage && !hideMenu && (
					<a href="#!" className="headerButton position-relative" aria-label={t('notification.button.manage')} onClick={(e) => { e.preventDefault(); setShowAS(true); }}>
						<ion-icon name="ellipsis-vertical-outline"></ion-icon>
					</a>
				)}
				{/* IMP-445: 알림 화면에서는 같은 경로 재이동이라 종이 무동작이 되므로 그 자리를 닫기 버튼으로 쓴다
				    (사용자 화면 /Notification 헤더와 동일 구성: [닫기] + [삼점 관리]) */}
				{isNotificationPage && (
					<a href="#!" className="headerButton" aria-label={t('common.button.close')} onClick={(e) => { e.preventDefault(); history.goBack(); }}>
						<ion-icon name="close-outline"></ion-icon>
					</a>
				)}
				{/* IMP-445: 외부 딜러 포함 노출은 확정 결정(자기 알림 수신), hideMenu 계정은 상단바 계약(햄버거·대시보드 컨트롤·Logout)에 맞춰 제외 */}
				{!isNotificationPage && !isPmcf && !hideMenu && <HomeAlaram />}
			</div>
			<Modal show={searchPartModal.show} onHide={() => {
				setSearchPartModal({...searchPartModal, show : false});
				setPartSn('');
			}}>
				<Modal.Header>
					<h5 className="modal-title">{t('service.button.downloadCalibration')}</h5>
				</Modal.Header>
				<Modal.Body className="p-3">
					<div className="form-group basic">
						<div className="input-wrapper">
							<InputBasicText
								options={{
									label: t('product.field.sn'),
									name: "partSn",
									placeholder: t('product.field.sn'),
									val: partSn
								}}
								onchange={(e) => setPartSn(e.target.value)}
								editable={true}
							/>
						</div>
					</div>
					<button
						className="btn btn-block btn-primary mt-3"
						onClick={handleSearchAndDownload}
						disabled={!partSn.trim() || isSearching}
					>
						{isSearching ? t('common.message.info.searching') : t('common.button.searchAndDownload')}
					</button>
				</Modal.Body>
			</Modal>
			<Modal show={modal.show} onHide={() => setModal({...modal, show : false})}>
				<Modal.Header>
					<h5 className="modal-title">{t('common.label.globalFilter')}</h5>
				</Modal.Header>
				<Modal.Body className=" p-2">
					<InputSelect2WithGroup options={{
						name: "showmodel",
						list: getModels(),
						isMulti : true,
						onlyitems : true,
						val: sm || [''],
					}} onchange={(e) => {
						let mm = ['']
						if(e.target.value.length > 0){
							if(e.target.value[e.target.value.length - 1] === ''){
								mm = [''];
							}else{
								mm = e.target.value.filter(n => n !== '')
							}
						}
						setSM(mm);
					}  } editable={true} style />
					<button className="btn btn-block btn-primary" data-bs-dismiss="modal" onClick={() => applyFilter()}>{t('common.button.apply')}</button>
				</Modal.Body>
			</Modal>
			<Modal show={showAS} className="action-sheet" dialogClassName="menu-all" onHide={() => setShowAS(false)}>
				<Modal.Body>
					<div className="border-bottom p-2">
						<h2 className="modal-title text-left">{t('notification.button.manage')}</h2>
					</div>
					<ul className="listview flush transparent image-listview mt-1 no-line">
						<li>
							<a href="#!" className="item" onClick={(e) => { e.preventDefault(); ReadAll(); setShowAS(false); }}>
								<div className="icon-box text-primary">
									<ion-icon name="mail-unread-outline"></ion-icon>
								</div>
								<div className="in">{t('notification.button.readAll')}</div>
							</a>
						</li>
						<li className="border-top">
							<a href="#!" className="item" onClick={async (e) => {
									e.preventDefault();
									setShowAS(false);
									if (await confirm({ title: t('common.button.deleteAll'), message: t('common.message.confirm.delete'), danger: true })) DeleteAll();
								}}>
								<div className="icon-box text-danger">
									<ion-icon name="trash-outline"></ion-icon>
								</div>
								<div className="in">{t('common.button.deleteAll')}</div>
							</a>
						</li>
						<li className="border-top">
							<a href="#!" className="item" onClick={async (e) => {
									e.preventDefault();
									setShowAS(false);
									if (await confirm({ title: t('notification.button.deleteRead'), message: t('common.message.confirm.delete'), danger: true })) DeleteRead();
								}}>
								<div className="icon-box text-danger">
									<ion-icon name="trash-outline"></ion-icon>
								</div>
								<div className="in">{t('notification.button.deleteRead')}</div>
							</a>
						</li>
						<li className="border-top">
							<a href="#!" className="item" onClick={(e) => { e.preventDefault(); setShowAS(false); }}>
								<div className="icon-box text-danger">
									<ion-icon name="exit-outline"></ion-icon>
								</div>
								<div className="in">{t('common.button.cancel')}</div>
							</a>
						</li>
					</ul>
				</Modal.Body>
			</Modal>
			{dialog}
		</div>
	);
};

const mapState = (state) => {
	const loggingIn = state.AuthReducer.loggingIn;
	const dashboardtype = state.ProgramReducer.dashboardtype;
	const showSub = state.ProgramReducer.showSub;
	const showChart = state.ProgramReducer.showChart;
	const chartType = state.ProgramReducer.chartType;
	const automapplay = state.ProgramReducer.automapplay;
	const deviceCategory = state.ProgramReducer.deviceCategory;
	const user = state.AuthReducer.user;
	const clist = state.RayCodeReducer.items;
	const showmodel = state.ProgramReducer.showmodel;

	return { user, loggingIn, dashboardtype, showSub, showChart, chartType, automapplay, deviceCategory, clist, showmodel };
};

const mapDispatch = (dispatch) => ({
	Logout: () => dispatch(AuthAction.Logout()),
	DashboardType: (type) => dispatch(ProgramAction.DashboardType(type)),
	SetDeviceCategory: (category) => dispatch(ProgramAction.DeviceCategory(category)),
	ReadAll: () => dispatch(NotificationAction.ReadAll()),
	DeleteAll: () => dispatch(NotificationAction.DeleteAll()),
	DeleteRead: () => dispatch(NotificationAction.DeleteRead()),
});

export default connect(mapState, mapDispatch)(AdminTopMenu);
